import React, { useState, useEffect } from 'react';
import useStyles from '../../../styles';
import { IconButton, Modal, Backdrop, Fade, Box } from '@material-ui/core';
import Table, { columnType } from '../../../components/ClearingTable/Table';
import { Close as CloseIcon, CheckCircle as CheckCircleIcon } from '@material-ui/icons';
import { listMarginReqDetails } from '../../../services/ClientSummaryService';

export default function ClientSummaryMarginReqDetailsModal({
  onClose: handleClose,
  open: isOpen,
  value,
}) {
  const classes = useStyles();

  const [rows, setRows] = useState([]);

  const columns = [
    {
      name: 'symbol',
      label: 'Symbol',
    },
    {
      name: 'cusip',
      label: 'Cusip',
    },
    {
      name: 'symbolDescription',
      label: 'Symbol Description',
    },
    {
      name: 'assetType',
      label: 'Asset Type',
    },
    {
      name: 'closingPrice',
      label: 'Closing Price',
      type: columnType.price,
    },
    {
      name: 'isMarginable',
      label: 'Marginable',
      type: columnType.bool,
    },
    {
      name: 'leveragedFactor',
      label: 'Leveraged Factor',
    },
    {
      name: 'qty',
      label: 'Qty',
      type: columnType.quantity,
    },
    {
      name: 'previousQty',
      label: 'Previous Qty',
      type: columnType.quantity,
    },
    {
      name: 'marketValue',
      label: 'Market Value',
      type: columnType.amount,
    },
    {
      name: 'previousMarketValue',
      label: 'Previous Market Value',
      type: columnType.amount,
    },
    {
      name: 'exchangeReq',
      label: 'Exchange Req',
    },
    {
      name: 'exchangeRate',
      label: 'Exchange Rate',
      type: columnType.percentage,
    },
    {
      name: 'houseReq',
      label: 'House Req',
    },
    {
      name: 'houseRate',
      label: 'House Rate',
      type: columnType.percentage,
    },
    {
      name: 'fedReq',
      label: 'Fed Req',
    },
    {
      name: 'fedRate',
      label: 'Fed Rate',
      type: columnType.percentage,
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    selectableRows: 'none',
    responsive: 'standard',
  };

  useEffect(
    () => {
      async function init() {
        const data = await listMarginReqDetails(value);
        setRows(data.marginReqDetailsList);
      }

      if (isOpen) {
        init();
      }
    },
    // eslint-disable-next-line
    [isOpen]
  );

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modalBackdrop}
      open={isOpen}
      onClose={() => {
        handleClose();
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <div className={classes.tableModalFull}>
          <Box component="div" mt={2}>
            <Table
              title="Client Margin Requirement Details"
              data={rows}
              columns={columns}
              options={options}
            />
          </Box>

          <div className={classes.modalFooter}>
            <div className={classes.grdCellNone} style={{ marginRight: 10 }}>
              <div className={classes.modalCloseIcon} style={{ marginRight: 10 }}>
                <IconButton
                  aria-label="close"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <CloseIcon style={{ color: '#f1f1f1' }} />
                </IconButton>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
